export default {
    ENDPOINT_URL_CONTACT_ME_EMAIL: '/contactEmail'
}


// WEBPACK FOOTER //
// ./src/containers/properties/Properties.js